import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  API_URL_APPLICATIONS_FILES,
  APPLICATIONS, APPLICATIONS_DETAIL, DUPLICATE_AGENDA_SOLUTION, GET_APPLICATION_ID_FROM_UUID
} from 'manager/http-constants';
import { forkJoin, Observable } from 'rxjs';
import {
  API_RESPONSE,
  INPUT_INFORMATIONS_API_CONSTANT,
} from 'src/app/shared/constant/api-constant';
import {
  CONSTANT,
  FILE_EXTENSION,
  LOADING_KEY,
  NUMBER,
} from 'src/app/shared/constant/constant';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import {
  LoadData,
  LoadingState,
} from 'src/app/shared/html-parts/loading/loading-state';
import {
  MessageData,
  ToastMessageData,
} from 'src/app/shared/html-parts/message-common/message-data';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { Validator } from 'src/app/shared/validator/validator';
import { PostalNoDialogComponent } from '../common/postal-no-dialog/postal-no-dialog.component';
import { PlatformComponent } from '../platform.component';
import {GENERATE_INPUT_TYPE} from '../../../shared/generate/generate-input/constant';

@Component({
  selector: 'app-k101',
  templateUrl: './k101.component.html',
  styleUrls: ['./k101.component.scss', '../platform.component.scss'],
})

/**
 * 入会申請(K101)
 * 入会申請確認(K102)
 */
export class K101Component extends PlatformComponent {
  /** 共通部品_郵便番号ダイアログ */
  @ViewChild(PostalNoDialogComponent)
  postalNoDialogComponent: PostalNoDialogComponent;

  // 画面.入力フォーム
  k101ApplicationInputForm: FormGroup = this.formBuilder.group({
    // 会員種別
    class_id: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'class_id',
          INPUT_INFORMATIONS_API_CONSTANT.SINGLE_SELECT_TYPE
        ),
      ],
    }),
    // 団体名称
    organization_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'organization_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 団体名称フリガナ
    organization_kana: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'organization_kana',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 法人番号
    organization_no: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'organization_no',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 郵便番号
    postal_no: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'postal_no',
          INPUT_INFORMATIONS_API_CONSTANT.NUMBER_TYPE
        ),
      ],
    }),
    // 都道府県
    prefectures: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'prefectures',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 所在地（市区町村）
    city: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'city',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 所在地（町域）
    town_area: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'town_area',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 所在地（番地・建物）
    address_building: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member',
          'address_building',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 業種
    industry_id: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'industry_id',
          INPUT_INFORMATIONS_API_CONSTANT.SINGLE_SELECT_TYPE
        ),
      ],
    }),
    // 団体ウェブサイトURL
    url: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'url',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 部局名
    department_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'department_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 課室名
    division_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'division_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 役職
    jobposition_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'jobposition_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 氏名
    full_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'full_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 電話番号
    tel: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'tel',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // eメールアドレス
    email: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'user',
          'email',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // eメールアドレス確認登録
    email_confirmation: this.formBuilder.control(CONSTANT.EMPTY_STRING),
    // 2020プラットフォーム誓約書
    pledge: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'pledge',
          INPUT_INFORMATIONS_API_CONSTANT.FILE_TYPE
        ),
      ],
    }),
    // アンケート（１）きっかけ
    questionary1: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'questionary1',
          INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE
        ),
      ],
    }),
    // アンケート（１）きっかけ－9.その他
    questionary1_other: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'questionary1_other',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // アンケート（２）期待すること
    questionary2: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'questionary2',
          INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE
        ),
      ],
    }),
    // アンケート（２）期待すること-10.その他
    questionary2_other: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'questionary2_other',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // アンケート（３）マッチング方法
    questionary3: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'questionary3',
          INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE
        ),
      ],
    }),
    // アンケート（３）マッチング方法-5.その他
    questionary3_other: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'questionary3_other',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // アンケート（４）課題
    questionary4: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'questionary4',
          INPUT_INFORMATIONS_API_CONSTANT.RADIO_TYPE
        ),
      ],
    }),
    // アンケート（４）課題-14.その他
    questionary4_other: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'questionary4_other',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // アンケート（５）分科会
    questionary5: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'questionary5',
          INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE
        ),
      ],
    }),
    // アンケート（５）分科会-5.その他
    questionary6: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'application',
          'questionary6',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    application_uuid: this.formBuilder.control(CONSTANT.EMPTY_STRING),
  });

  // 規約確認状態
  ruleCheck: boolean;

  // 規約チェック状態
  ruleCheckFlag: boolean[] = [];

  // 確認画面表示フラグ(true=入会申請確認(K102),false=入会申請(K101))
  confirmationFlag = false;

  // 辞書情報格納先
  specCodeList: any;

  // プラットフォーム誓約書.ファイル名格納先
  fileName: string;

  selectedValue: string;

  applicationUuid = '';
  applicationId = 0;

  // 業種用辞書値格納先
  industryIdCodeList: any;

  // プラットフォーム誓約書存在フラグ
  pledge = false;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private validator: Validator,
    private messageData: MessageData
  ) {
    super(route, commonService, dbOperationService, loadingState);

    // urlを入会申請(K101)に変更する
    this.router.navigate(
      ['pages/platform/k101/' + this.route.snapshot.params.application_id],
      {
        queryParams: { screenId: 'k101' },
      }
    );

    this.applicationUuid = this.route.snapshot.params.application_id;
  }

  ngOnInit(): void {
    // 辞書値リストを取得
    this.getSpecCodeList(1, 2, 801, 802, 803, 804, 805);

    // 業務用辞書情報取得処理
    this.dbOperationService.getDicLists(2).subscribe((response) => {
      // 全辞書情報が存在するか否か
      if (!this.commonService.checkNoneResponse(response)) {
        // 辞書情報に存在する場合

        // 辞書情報を格納
        this.industryIdCodeList = response.body;
      } else {
        // 辞書情報に存在しない場合

        this.industryIdCodeList = null;
      }
    });

    this.setEditInitialData();
  }

  /**
   * 編集初期表示
   */
  private setEditInitialData = () => {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(GET_APPLICATION_ID_FROM_UUID);

    // 課題・ソリューション詳細を取得
    this.dbOperationService
      .getNoTemplateDisplayData(GET_APPLICATION_ID_FROM_UUID, this.applicationUuid, true)
      .subscribe((response) => {
        if (this.commonService.checkNoneResponse(response)) {
          // 異常メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
              position: TOAST.BOTTOM_RIGHT,
              life: 60000,
            })
          );
          return;
        } else {
          const applicationData = response.body;

          this.applicationId = applicationData.application_id;

          // 初期値セット
          this.commonService.setFormGroupInitialData(
            this.k101ApplicationInputForm,
            applicationData
          );
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, GET_APPLICATION_ID_FROM_UUID);

          // 画像ID存在フラグを設定する
          if (applicationData.pledge.id !== CONSTANT.EMPTY_STRING && applicationData.pledge.id.length !== 0) {
            this.pledge = true;
            this.k101ApplicationInputForm.get('pledge').setValue(applicationData.pledge.id);
            this.fileName = applicationData.pledge.name;
          }

          this.k101ApplicationInputForm.get('email_confirmation').setValue(applicationData.email);
          this.k101ApplicationInputForm.get('application_uuid').setValue(this.applicationUuid);
        }

      });
  }

  /**
   * emailアドレス確認チェック
   * @param input true:画面入力 false:初回
   */
  public checkConfirmationEmail(input?: boolean): void {
    // 画面入力されたか否か
    if (input) {
      // 画面入力された場合

      // 変更検知をtrueにする(エラーメッセージ表示有無フラグ)
      this.k101ApplicationInputForm.get('email_confirmation').markAsDirty();
    }

    // 画面.入力フォーム.パスワード確認を取得
    const emailConfirmation =
      this.k101ApplicationInputForm.get('email_confirmation').value;

    // 画面.入力フォーム.パスワード確認が未入力か否か
    if (!emailConfirmation) {
      // 未入力の場合

      // 必須項目エラー
      this.k101ApplicationInputForm.controls.email_confirmation.setErrors({
        message: '必須項目です。必ず入力してください。',
      });

      return;
    }

    // 画面.入力フォーム.パスワード確認がパスワードと同様か確認
    if (emailConfirmation != this.k101ApplicationInputForm.get('email').value) {
      // 同様でない場合
      this.k101ApplicationInputForm.controls.email_confirmation.setErrors({
        message: 'emailアドレスの値と一致していません',
      });
      return;
    }

    // エラーメッセージを空にする
    this.k101ApplicationInputForm.controls.email_confirmation.setErrors(
      null
    );

    return;
  }

  /**
   * ファイルアップロード
   * @param event ファイル情報
   * @param fileUpload ボタン動作状態
   */
  public uploadFile(event: any, fileUpload: any) {

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(API_URL_APPLICATIONS_FILES);

    // ファイル情報からファイル名を取得
    const fileName = event.files[0].name;

    // 拡張子を取得
    const extension = event.files[0].name.substring(
      event.files[0].name.lastIndexOf(CONSTANT.PERIOD)
    );

    // 拡張子がpdfまたはPDFか否か判定
    if (
      !(FILE_EXTENSION.PDF == extension || FILE_EXTENSION.PDF2 == extension)
    ) {

      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadSleepEnd(0.3, API_URL_APPLICATIONS_FILES);

      // 拡張子がpdfまたはPDF以外の場合
      // 拡張子エラーメッセージ
      this.messageData.toastMessage(
        new ToastMessageData({
          severity: TOAST.ERROR,
          summary: this.commonService.msg(MESSAGE_CODE.E00012),
          detail: this.commonService.msg(MESSAGE_CODE.E00013, 'pdf'),
        })
      );

      // ボタン動作状態をクリア
      fileUpload.clear();

      // 処理を終了
      return;
    }

    // ファイルサイズの判定
    if (NUMBER.ZERO == event.files[0].size || 10485760 <= event.files[0].size) {
      // ファイルサイズが0KBの場合 または
      // 10MB以上の場合

      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadSleepEnd(0.3, API_URL_APPLICATIONS_FILES);

      // 画像サイズエラーメッセージ
      this.messageData.toastMessage(
        new ToastMessageData({
          severity: TOAST.WARN,
          summary: this.commonService.msg(MESSAGE_CODE.E00012),
          detail: this.commonService.msg(
            MESSAGE_CODE.E00025,
            '1KB以上、10MB以下'
          ),
        })
      );

      // ボタン動作状態をクリア
      fileUpload.clear();

      // 処理を終了
      return;
    }

    // ファイル情報(base64)取得処理
    this.commonService.getBase64(event.files[0]).then((b64) => {
      const csize = 5000000;   // 5MBで分割
      const lc = (Math.floor(b64.length / csize) + 1);  // 全ループ回数＝分割数
      let s: number;
      let e: number;
      let b64_konkai: string;    // ループ毎に処理するbase64エンコード
      const b64_arr = [];   // バッファ

      // 先頭部分の除去
      b64 = b64.replace(/^data:.*?;base64,/, '');

      for (let c = 0; c < lc; c++) {
        // 開始Indexと終了Index
        s = c * csize;
        e = (s + csize);
        if (e >= b64.length) {
          e = b64.length;
        }

        // バッファ配列にセット
        b64_konkai = b64.substring(s, e);
        b64_arr.push(b64_konkai);
      }

      // ファイル登録を実施 処理部分
      const file_register = (b64_arr: Array<any>, lc: number) => {
        return new Promise(resolve => {
          this.dbOperationService
            .insertFileResult(API_URL_APPLICATIONS_FILES, fileName, b64_arr[0], 1, lc)
            .subscribe((response) => {
              // フォームコントロール(ファイル登録)変更検知をtrueにする(エラーメッセージ表示有無フラグ)
              this.k101ApplicationInputForm.get('pledge').markAsDirty();

              // 画面.入力フォームにファイルIDを格納
              this.k101ApplicationInputForm.get('pledge').setValue(response.body.file_id);

              // ファイル名を格納
              this.fileName = fileName;

              // 分割2回目～
              if (lc >= 2) {
                const arr = [];
                for (let c = 2; c <= lc; c++) {
                  arr.push(c);
                }
                (async () => {
                  for await (const num of arr) {
                    const res = await file2_register(num);
                  }
                  resolve('ok');
                })();
              } else { resolve('ok'); }

              const file2_register = (n: number) => {
                return new Promise(resolve2 => {
                  this.dbOperationService
                    .insertFileResult(API_URL_APPLICATIONS_FILES, fileName, b64_arr[n - 1], n, lc)
                    .subscribe((response) => {
                      resolve2(response.body);
                    });
                });
              };
            });
        });
      };
      // ファイル登録を実施
      (async () => {
        const f_s = await file_register(b64_arr, lc);
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, API_URL_APPLICATIONS_FILES);
      })();
    });

    // 初期画像表示ID削除
    this.breakImgCaptionFlg();
  }

  /**
   * アップロードファイル削除
   */
  public deleteFile() {
    // フォームコントロール(ファイル登録)変更検知をtrueにする(エラーメッセージ表示有無フラグ)
    this.k101ApplicationInputForm.get('pledge').markAsDirty();

    // 画面.入力フォームからファイル情報を削除
    this.k101ApplicationInputForm.get('pledge').setValue(CONSTANT.EMPTY_STRING);

    // ファイル名を格納
    this.fileName = CONSTANT.EMPTY_STRING;

    // 初期画像表示ID削除
    this.breakImgCaptionFlg();
  }

  /**
   * 入会申請(K101)を表示する
   */
  public moveK101(): void {
    // 入会申請(K101)へ遷移
    this.router.navigate(
      ['pages/platform/k101/' + this.route.snapshot.params.application_id],
      {
        queryParams: { screenId: 'k101' },
      }
    );

    // 入会申請(K101)を表示する
    this.confirmationFlag = false;
  }

  /**
   * 入会申請確認(K102)を表示する
   */
  public moveK102(): void {
    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    const k101ApplicationInputForm: any = JSON.parse(
      JSON.stringify(this.k101ApplicationInputForm.value)
    );

    {
      if (k101ApplicationInputForm.pledge.id != CONSTANT.EMPTY_STRING
        && k101ApplicationInputForm.pledge.id?.length != 0) {
        this.pledge = true;
      }
    }
    const fileName = k101ApplicationInputForm.pledge.name;

    // 配列をカンマ区切り変換
    {
      // アンケート（１）きっかけ
      k101ApplicationInputForm.questionary1 =
        k101ApplicationInputForm.questionary1.toString();

      // アンケート（２）期待すること
      k101ApplicationInputForm.questionary2 =
        k101ApplicationInputForm.questionary2.toString();

      // アンケート（３）マッチング方法
      k101ApplicationInputForm.questionary3 =
        k101ApplicationInputForm.questionary3.toString();

      // アンケート（4）
      k101ApplicationInputForm.questionary4 =
        k101ApplicationInputForm.questionary4.toString();

      // アンケート（５）分科会
      k101ApplicationInputForm.questionary5 =
        k101ApplicationInputForm.questionary5.toString();
    }

    // 画面カスタムロードフラグをON(ロード中状態)
    this.loadingState.customLoadStart(
      new LoadData({
        loadingText: '',
        background_color: '',
        opacity: 0.3,
      })
    );

    /* 入力項目値バリデーションチェック */
    // 非同期同時実行リスト
    const task: Observable<any>[] = [
      /* 共通バリデーションチェック */
      this.dbOperationService.multiValidationResult(
        'application',
        k101ApplicationInputForm
      ),
    ];

    // 非同期同時実行
    forkJoin(task).subscribe((dataList) => {
      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadEnd();

      // 入会申請確認(K102)へ遷移
      this.router.navigate(
        ['pages/platform/k101/' + this.route.snapshot.params.application_id],
        {
          queryParams: { screenId: 'k102' },
        }
      );

      // 入会申請確認(K102)を表示する
      this.confirmationFlag = true;
    });
  }

  /**
   * 入会申請メールアドレス確認(K103)へ遷移する
   */
  public moveK103(): void {
    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    const k101ApplicationInputForm: any = JSON.parse(
      JSON.stringify(this.k101ApplicationInputForm.value)
    );

    // 配列をカンマ区切り変換
    {
      // アンケート（１）きっかけ
      k101ApplicationInputForm.questionary1 =
        k101ApplicationInputForm.questionary1.toString();

      // アンケート（２）期待すること
      k101ApplicationInputForm.questionary2 =
        k101ApplicationInputForm.questionary2.toString();

      // アンケート（３）マッチング方法
      k101ApplicationInputForm.questionary3 =
        k101ApplicationInputForm.questionary3.toString();

      // アンケート（4）
      k101ApplicationInputForm.questionary4 =
        k101ApplicationInputForm.questionary4.toString();

      // アンケート（５）分科会
      k101ApplicationInputForm.questionary5 =
        k101ApplicationInputForm.questionary5.toString();
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOADING_KEY.DATA_INSERT);

    // 会員申請登録を実施
    this.dbOperationService
      .insertData(APPLICATIONS, k101ApplicationInputForm)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

        // レスポンス結果を判定
        if (API_RESPONSE.SUCCESS == response.body.Message) {
          // 正常終了の場合

          // 入会申請メールアドレス確認(K103)へ遷移
          this.router.navigate(['pages/platform/k103'], {
            queryParams: {
              email: k101ApplicationInputForm.email,
            },
          });
        } else {
          // 異常終了の場合

          // 異常終了メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00001),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
            })
          );

          // 入会申請(K101)を表示する
          this.confirmationFlag = false;
        }
      });
  }

  /**
   * 郵便番号ダイアログ表示
   */
  public openPostalNoDialog() {
    // 郵便番号ダイアログを表示
    this.postalNoDialogComponent.openPostalNoDialog();
  }

  /**
   * 郵便番号セット
   * @param postalNoData 郵便番号情報
   */
  public setPostalNo(postalNoData: any): void {
    // 郵便番号情報をセット
    // 郵便番号
    {
      this.k101ApplicationInputForm.get('postal_no').markAsDirty();
      this.k101ApplicationInputForm
        .get('postal_no')
        .setValue(postalNoData.postal_no);
    }

    // 都道府県
    {
      this.k101ApplicationInputForm.get('prefectures').markAsDirty();
      this.k101ApplicationInputForm
        .get('prefectures')
        .setValue(postalNoData.prefectures);
    }

    // 所在地（市区町村）
    {
      this.k101ApplicationInputForm.get('city').markAsDirty();
      this.k101ApplicationInputForm.get('city').setValue(postalNoData.city);
    }

    // 所在地（町域）
    {
      this.k101ApplicationInputForm.get('town_area').markAsDirty();
      this.k101ApplicationInputForm
        .get('town_area')
        .setValue(postalNoData.town_area);
    }
    // 所在地（番地・建物）
    {
      this.k101ApplicationInputForm.get('address_building').markAsDirty();
      this.k101ApplicationInputForm
        .get('address_building')
        .setValue(postalNoData.address_building);
    }
  }

  /**
   * 初期画像IDフラグの削除
   * @param formName フォーム項目名
   */
  public breakImgCaptionFlg(): void {
    // フラグを折る
    this.pledge = false;
  }
}
